export const isInfiniteBlock = (block, isRepeating = false) => {
    if (!block) {
        return false;
    }

    if (isRepeating) {
        return true;
    }

    const parentBlock = block.parent_block ? block.parent_block : block;
    const hasAudioRepeat = parentBlock.settings.find(setting => setting.name === 'repeat_audio');
    const isFixedBlock = parentBlock.settings.find(setting => setting.name === 'fixed_block');

    if (isFixedBlock) {
        return true;
    }

    if (parentBlock.songs_override_id && parentBlock.songs_override_id !== parentBlock.id) {
        return true;
    }

    const isNormalBlock = parentBlock.type === 1 /*1 = image */ ||
        parentBlock.type === 3 /*3 = spreker */ ||
        (parentBlock.type === 4 && block.type === 1) // check if parent is media and subblock is image

    const isInfinite = (
        parentBlock.type === 5 /*5 = inloop / uitloop */ ||
        parentBlock.type === 6 /*6 = condolence */ ||
        isNormalBlock
    ) && hasAudioRepeat && hasAudioRepeat.value === '1';

    if (isInfinite && isNormalBlock && parentBlock.files.length) {
        return false;
    }

    return isInfinite;
}

export const getMaxDurationFromBlock = (ceremony, block, isRepeating = false) => {
    if (!block) {
        return 0;
    }

    if (isInfiniteBlock(block, isRepeating)) {
        return 60 * 60 * 8;//(ceremony.type === 'condolence' ? 3 : 1); // condolence we want to repeat for max 3 uur, normal ceremony for 1 hour
    }

    return (block.total_duration ? block.total_duration : block.block_duration);
}
